// components/CartIcon.jsx
import React from 'react';
import { FiShoppingCart } from 'react-icons/fi';
import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';

const CartIcon = () => {
  const { cartItemCount } = useCart();
  
  return (
    <Link to="/cart" className="relative">
      <FiShoppingCart className="w-6 h-6 text-gray-700 hover:text-blue-600" />
      {cartItemCount > 0 && (
        <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
          {cartItemCount > 9 ? '9+' : cartItemCount}
        </span>
      )}
    </Link>
  );
};

export default CartIcon;